import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ToastService } from 'ng-uikit-pro-standard';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';

@Component({
  selector: 'app-modal-rutas-divididas',
  templateUrl: './modal-rutas-divididas.component.html',
  styleUrls: ['./modal-rutas-divididas.component.scss']
})
export class ModalRutasDivididasComponent implements OnInit {
  @ViewChild('modalRutasDivididas', { static: true }) modalRutasDivididas: ModalDirective;
  @Output() onMostrarRuta: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCerrarRuta: EventEmitter<number> = new EventEmitter<number>();

  rutasDivididas: Array<any> = [];
  totalPuntos: number = 0;
  rutasMostradas: Set<number> = new Set();
  alertasRutas: Map<number, boolean> = new Map();
  beachesRutasOriginales: any[] = []; // Guardar las rutas originales para reconstruir puntos

  // Utils
  private log: any;

  constructor(
    private toastService: ToastService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService
  ) {
    this.log = this.clog.log('MODAL RUTAS DIVIDIDAS');
  }

  ngOnInit() {
  }

  loadAndShow(beachesRutas: any[]) {
    this.rutasDivididas = [];
    this.rutasMostradas.clear();
    this.alertasRutas.clear();
    this.totalPuntos = beachesRutas.length;
    this.beachesRutasOriginales = beachesRutas; // Guardar las rutas originales

    // Dividir las rutas en grupos de máximo 25 puntos (límite de Google Maps)
    const LIMITE_PUNTOS = 25;
    const totalRutas = Math.ceil(beachesRutas.length / LIMITE_PUNTOS);

    for (let i = 0; i < totalRutas; i++) {
      const inicio = i * LIMITE_PUNTOS;
      const fin = Math.min(inicio + LIMITE_PUNTOS, beachesRutas.length);
      const puntosRuta = beachesRutas.slice(inicio, fin);

      // Obtener punto inicial y final
      // Si no es la primera ruta, el punto inicial debe ser el punto final de la ruta anterior
      let puntoInicial;
      if (i === 0) {
        // Primera ruta: punto inicial es el primer punto del bloque
        puntoInicial = puntosRuta[0];
      } else {
        // Rutas siguientes: punto inicial es el punto final de la ruta anterior (continuidad)
        puntoInicial = beachesRutas[inicio - 1];
      }

      const puntoFinal = puntosRuta[puntosRuta.length - 1];

      this.rutasDivididas.push({
        numero: i + 1,
        puntos: puntosRuta,
        cantidadPuntos: puntosRuta.length,
        puntoInicial: puntoInicial[0], // dirección
        puntoFinal: puntoFinal[0], // dirección
        latInicial: puntoInicial[1],
        lngInicial: puntoInicial[2],
        latFinal: puntoFinal[1],
        lngFinal: puntoFinal[2],
        esUltima: i === totalRutas - 1,
        mostrarEnMapa: false,
        puntoInicialCompleto: puntoInicial, // Guardar el punto inicial completo para rutas siguientes
        indiceInicio: inicio // Guardar el índice de inicio para reconstruir
      });
    }

    this.modalRutasDivididas.show();
  }

  mostrarRutaEnMapa(ruta: any) {
    // Cambiar estado visual del botón
    ruta.mostrarEnMapa = true;
    this.rutasMostradas.add(ruta.numero);
    this.alertasRutas.set(ruta.numero, true);

    // Construir los puntos para el mapa
    let puntosParaMapa = [...ruta.puntos];

    // Determinar el origen:
    // - Ruta 1: usar null (se usará la bodega/distribuidor donde se carga el camión)
    // - Ruta 2 y siguientes: usar el punto inicial de esa ruta (que es el punto final de la ruta anterior)
    let origenPersonalizado = null;
    if (ruta.numero > 1 && ruta.puntoInicialCompleto) {
      // Para rutas 2, 3, etc., usar el punto inicial como origen (continuidad)
      // El punto inicial de la Ruta 2 es el punto final de la Ruta 1
      origenPersonalizado = ruta.puntoInicialCompleto;
      console.log(`📍 Ruta ${ruta.numero}: Usando origen personalizado desde ${ruta.puntoInicialCompleto[0]}`);
    } else {
      console.log(`📍 Ruta ${ruta.numero}: Usando bodega como origen (carga del camión)`);
    }
    // Si es ruta 1, origenPersonalizado será null y se usará la bodega

    // Emitir evento para que el componente padre muestre la ruta en el mapa
    this.onMostrarRuta.emit({
      puntos: puntosParaMapa,
      numeroRuta: ruta.numero,
      origenPersonalizado: origenPersonalizado
    });

    // Mostrar alerta visual
    this.showInfo(`Ruta ${ruta.numero} se mostrará en el mapa principal`);

    // Ocultar la alerta después de 3 segundos
    setTimeout(() => {
      this.alertasRutas.set(ruta.numero, false);
    }, 3000);
  }

  resetearColorRuta(numeroRuta: number) {
    // Resetear el color del bloque cuando se cierra el modal de rutas
    this.rutasMostradas.delete(numeroRuta);
    const ruta = this.rutasDivididas.find(r => r.numero === numeroRuta);
    if (ruta) {
      ruta.mostrarEnMapa = false;
    }
  }

  cerrar() {
    this.modalRutasDivididas.hide();
    this.rutasDivididas = [];
    this.rutasMostradas.clear();
    this.alertasRutas.clear();
  }

  showInfo(mensaje: string) {
    const options = { opacity: 1 };
    this.toastService.info(mensaje, 'Información', options);
  }
}

